<template>
  <div class="app-wrapper">
    <div class="app-container">
      <router-view />
    </div>
  </div>
</template>

<script>
import { extractReferralCodeFromQuery, storeReferralCode } from '@/helpers/referralAttribution';

export default {
  name: 'App',
  created() {
    this.$store.dispatch('fetchI18N');
    this.$store.dispatch('fetchSocialNetworks');
    this.handleReferral();
  },
  watch: {
    '$route.query'(query) {
      if (query) {
        this.handleReferral();
      }
    },
  },
  methods: {
    async handleReferral() {
      const code = extractReferralCodeFromQuery(this.$route.query);

      if (!code) {
        return;
      }

      storeReferralCode(code);
      await this.$store.dispatch('attachStoredReferral');
    }
  }
}
</script>

<style lang="scss">
@import "normalize-scss";
@include normalize();
@import "@/assets/styles/helpers";
@import "@/assets/styles/fonts";
@import "@/assets/styles/mixins";

.app-wrapper {
  font-family: 'Space Mono', sans-serif;
  background: #F3F3F3;
  display: flex;
  justify-content: center;
}

.app-container {
  width: 100%;
  display: flex;
  justify-content: center;
  flex-flow: column;

  @include respond-above(sm) {
    box-sizing: border-box;
  }
}

.no-gutters {
  .app-content-wrapper {
    padding-left: 0;
    padding-right: 0;
    z-index: 20;
    margin: 0 auto;
  }
}

.app-content-wrapper {
  position: relative;
  width: calc(100% - 30px);
  max-width: 1280px;
  padding: 0 15px;

  @include respond-between(md, lg) {
    max-width: 1024px;
    padding: 0 40px;
  }

  @include respond-between(sm, md) {
    max-width: 700px;
  }

  @include respond-to(xs) {
    padding: 0;
    box-sizing: border-box;
  }

  .with-background {
    background: radial-gradient(55.22% 90.9% at 50.79% 44.82%, #41444E 0%, #2C3037 100%);
    box-shadow: 0 0 65px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
    padding: 60px 45px;

    @include respond-to(xs) {
      padding: 0;
      background: transparent;
      box-shadow: none;
    }
  }
}

</style>
